import { useEffect } from "react"

import { Locale } from "@shared/enums/general"

import { useCookie } from "./cookie"
import { useLocalState } from "./useLocalState"

/**
 * The cookie `LOCALE_KEY` is only used in our E2E tests
 * @deprecated
 */
export const LOCALE_KEY = "locale-v2"

/**
 * Local storage key to save the preferred locale
 */
export const USER_LOCALE_KEY = "userLocale"

export let DEFAULT_LOCALE = Locale.Nl

/**
 * For testing purposes: Adjust the default locale
 */
export function setDefaultLocale(locale: Locale): void {
  DEFAULT_LOCALE = locale
}

/**
 * Get access to the current locale of the website. Defaults to Dutch language.
 */
export function useLocale(): Locale {
  const [fallbackLocale] = useCookie(LOCALE_KEY, DEFAULT_LOCALE)
  const [locale] = useLocalState(USER_LOCALE_KEY, fallbackLocale)

  return locale
}

/**
 * Hook to get both locale value and setter function. Defaults to Dutch language.
 */
export function useLocaleWithSetter(): { locale: Locale; setLocale: (locale: Locale) => void } {
  const [fallbackLocale] = useCookie(LOCALE_KEY, DEFAULT_LOCALE)
  const [locale, setLocale] = useLocalState(USER_LOCALE_KEY, fallbackLocale)

  // Make sure google translate picks up the correct language
  useEffect(() => {
    const localePrefix = locale.substring(0, 2)
    document.documentElement.lang = localePrefix
    document.querySelector("meta[http-equiv='Content-Language']")?.setAttribute("content", localePrefix)
  }, [locale])

  return { locale, setLocale }
}
